import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ClearIcon = ({
  color = 'black50',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM6.4644 13.5356C6.07388 13.1451 6.07388 12.5119 6.4644 12.1214L8.58576 10L6.4645 7.87876C6.07397 7.48824 6.07397 6.85507 6.4645 6.46455C6.85502 6.07402 7.48818 6.07402 7.87871 6.46455L9.99997 8.58581L12.1213 6.46452C12.5118 6.074 13.1449 6.074 13.5355 6.46452C13.926 6.85505 13.926 7.48821 13.5355 7.87874L11.4142 10L13.5356 12.1214C13.9261 12.5119 13.9261 13.1451 13.5356 13.5356C13.145 13.9261 12.5119 13.9261 12.1213 13.5356L9.99997 11.4142L7.87862 13.5356C7.48809 13.9261 6.85493 13.9261 6.4644 13.5356Z"
      />
    </svg>
  </DefaultIconWrapper>
);
